import { APP_V2_APP_EVENTS, APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { BottomSheet, type BottomSheetProps } from "@src/appV2/redesign/system/ui-components";
import { useCallback } from "react";

import { DocumentSubmissionApprovedBottomSheetContent } from "../../Documents/Submission/ApprovedContent";
import { ONBOARDING_STAGES } from "../util/constants";
import { type OnboardingPersonalIdVerificationAnalytics } from "./types";

type OnboardingPersonalIdVerificationApprovedBottomSheetProps = {
  isLoading: boolean;
  onContinue: () => void;
  analytics: OnboardingPersonalIdVerificationAnalytics;
} & Pick<BottomSheetProps, "modalState" | "canDismiss" | "paperSx">;

export function OnboardingPersonalIdVerificationApprovedBottomSheet(
  props: OnboardingPersonalIdVerificationApprovedBottomSheetProps
) {
  const { canDismiss, modalState, paperSx, isLoading, onContinue, analytics } = props;

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  useLogEffect(APP_V2_APP_EVENTS.ONBOARDING_PERSONAL_ID_APPROVED_BOTTOM_SHEET_VIEWED, {
    ...analytics,
  });

  return (
    <BottomSheet
      canDismiss={canDismiss}
      footer={
        <DialogFooter orientation="vertical">
          <LoadingButton
            fullWidth
            isLoading={isLoading}
            size="large"
            onClick={() => {
              logEvent(APP_V2_USER_EVENTS.ONBOARDING_STEP_COMPLETED, {
                stepCompleted: ONBOARDING_STAGES.PERSONAL_ID_VERIFICATION,
                personalIdState: "approved",
              });
              onContinue();
            }}
          >
            Continue
          </LoadingButton>
        </DialogFooter>
      }
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
      paperSx={paperSx}
    >
      <DocumentSubmissionApprovedBottomSheetContent
        title="Your ID Has Been Verified!"
        showConfetti={false}
      />
    </BottomSheet>
  );
}
